import Vue from 'vue'

import { PulseLoader } from 'vue-spinner/dist/vue-spinner.min.js'

Vue.component('pulse-loader', PulseLoader);